import React, { useState } from 'react';
import { useRouter } from 'expo-router';
import { useLocale } from '../../hooks/useLocale';
import { MaterialSymbol } from '../icons/MaterialSymbol';

export interface WebFloatingBackButtonProps {
  fallbackHref?: string;
  onPress?: () => void;
}

export function WebFloatingBackButton({
  onPress,
  fallbackHref,
}: WebFloatingBackButtonProps) {
  const router = useRouter();
  const { isRTL } = useLocale();
  const [hover, setHover] = useState(false);

  const handlePress = () => {
    if (onPress) {
      onPress();
      return;
    }
    if (router.canGoBack()) {
      router.back();
      return;
    }
    if (fallbackHref) {
      router.replace(fallbackHref as never);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePress}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label="Back"
      style={{
        position: 'absolute',
        top: 16,
        insetInlineStart: 16,
        zIndex: 20,
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: 0,
        background: hover ? 'var(--hover-strong)' : 'transparent',
        color: 'var(--text-secondary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'background-color 150ms',
        fontFamily: 'inherit',
      }}
    >
      <MaterialSymbol
        name={isRTL ? 'arrow_forward' : 'arrow_back'}
        size={20}
      />
    </button>
  );
}
